import React, { Suspense, useEffect } from 'react';
import NavBar from '../CommonLayout/NavBar';
import SideBar from './SideBar';
import SignIn from '../../pages/ExtraPages/SignIn';
import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setEmailRedux,
  setLoginAgencyID,
  setPasswordRedux,
  setUserAppNotifications,
  setUserDetailsObj,
  setUserToken
} from '../../Redux/UserSlice';
import { Alert, Button, Grid } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setRateValues } from '../../Redux/GetRatesSlice';
import {
  setQuickQuoteRateValues,
  setQuickQuoteTLRateValues
} from '../../Redux/QuickQuoteRateSlice';
import SkeletonLoader from '../../components/TmsLoader';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { GetAppNotifications } from '../../apis/Agency';
import { ErrorToast } from '../../components/Toasts';
import { ToastContainer } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import { enqueueSnackbar, SnackbarProvider } from 'notistack';

const Layout = props => {
  const location = useLocation();
  const CurrentRoute = location.pathname;
  const selectedModuleName = localStorage.getItem('selectedModulePersist');

  var layoutMode = document.body.getAttribute('data-layout-mode');

  const history = useHistory();
  const [state, setState] = useState('Active');
  const [count, setCount] = useState(0);
  const [invalidUrl, setInvalidUrl] = useState('');
  const [invalidModuleDialog, setInvalidModuleDialog] = useState(false);
  const dispatch = useDispatch();
  const rememberMe = useSelector(state => state.userDetails.rememberMe);
  const [userRolePermissionsArray, setUserRolePermissionsArray] =
    useState(null);
  // const UserId = useSelector(state => state.userDetails.token);
  const UserId = sessionStorage.getItem('UserAuthToken');
  const tokenExpiry = localStorage.getItem('tokenExpiryTime');

  const tokenExpiryTime = new Date(tokenExpiry);
  const currentTime = new Date();
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const [routesArray, setRoutesArray] = useState(null);
  const handleClickOpen = () => {
    setInvalidModuleDialog(true);
  };

  const handleClose = () => {
    setInvalidModuleDialog(false);
  };

  useEffect(() => {
    // Use a Set to ensure unique values in the array
    const updatedArray = new Set();
    const routesArray = new Set();
    // Iterate through userRolePermissions
    userRolePermissions?.forEach(permission => {
      const allLevelsTrue =
        !permission.level1 &&
        !permission.level2 &&
        !permission.level3 &&
        !permission.level4 &&
        !permission.level5;
      const dashboardAllLevelsTrue =
        !permission.level1 &&
        !permission.level2 &&
        !permission.level3 &&
        !permission.level4 &&
        !permission.level5 &&
        !permission.level6 &&
        !permission.level7 &&
        !permission.level8 &&
        !permission.level9 &&
        !permission.level10;
      console.log(dashboardAllLevelsTrue, 'dashboardAllLevelsTrue');
      if (!dashboardAllLevelsTrue) {
        updatedArray.add(permission.permissionName);
        if (permission.permissionName.includes('Dashboard')) {
          routesArray.add('/dashboard');
        }
      }
      if (!allLevelsTrue) {
        // Add the permissionName to the Set
        if (permission.permissionName.includes('Quick')) {
          routesArray.add('/quick-quote');
          routesArray.add('/bookshipment');
          routesArray.add('/bookshipmentTL');
        }
        updatedArray.add(permission.permissionName);
        // if (permission.permissionName.includes('Dashboard')) {
        //   routesArray.add('/dashboard');
        //   routesArray.add('/user-dashboard');
        //   routesArray.add('/new-dashboard');
        //   routesArray.add('/claims-dashboard');
        // }
        if (permission.permissionName.includes('Carriers')) {
          routesArray.add('/carriers');
          routesArray.add('/create-carrier');
        }
        if (permission.permissionName.includes('Users')) {
          routesArray.add('/users');
        }
        if (permission.permissionName.includes('Roles')) {
          routesArray.add('/roles');
        }
        if (permission.permissionName === 'Manage-Shipments') {
          routesArray.add('/manage-shipments');
          routesArray.add('/dispatchshipmentLTL');
          routesArray.add('/bookshipmentTL');
          routesArray.add('/dispatchshipmentParcel');
          routesArray.add('/dispatchshipmentTL');
        }

        if (permission.permissionName.includes('Locations')) {
          routesArray.add('/view-locations');
          routesArray.add('/add-locations');
        }
        if (permission.permissionName.includes('Settings')) {
          routesArray.add('/settings');
        }

        if (permission.permissionName.includes('App-Registration')) {
          routesArray.add('/app-registration');
        }
        if (permission.permissionName.includes('Invoice-Audit')) {
          routesArray.add('/invoice-audit');
        }
        if (permission.permissionName === 'Track-Shipments') {
          routesArray.add('/track-shipment');
        }
        if (permission.permissionName.includes('Logs')) {
          routesArray.add('/Logs');
        }
        routesArray.add('/user-profile');
        routesArray.add('/notifications');
        routesArray.add('/user-dashboard');
        routesArray.add('/new-dashboard');
        routesArray.add('/claims-dashboard');
        routesArray.add('/');
      }
    });

    // Convert the Set back to an array and update the state
    setUserRolePermissionsArray(Array.from(updatedArray));
    setRoutesArray(Array.from(routesArray));
  }, [userRolePermissions]);
  const currentScreen = useLocation();
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  // useEffect(() => {
  //   const pathName = currentScreen?.pathname?.toLowerCase();
  //   const routeAssigned =
  //     routesArray &&
  //     routesArray.find(
  //       item => item.toLowerCase() === pathName // Compare the lowercase path name with permission
  //     );
  //   if (routesArray?.length > 0 && !routeAssigned && !UserIsAdmin) {
  //     history.push('/not-authorized');
  //   }
  // }, [routesArray]);

  useEffect(() => {
    // Function to get the value of a specific cookie by name
    const getCookieValue = cookieName => {
      const cookies = document.cookie.split('; ');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');
        if (cookie[0] === cookieName) {
          return cookie[1];
        }
      }
      return null;
    };

    // Usage: Get the value of "yourCookieName"
    const yourCookieValue = getCookieValue('userInfo');
    if (yourCookieValue === null) {
      handleResetLocalStorage();
    }
  }, []);

  setTimeout(() => {
    if (tokenExpiryTime - currentTime <= 0) {
      window.location.href = '/agency-signin';
      localStorage.clear();
      localStorage.setItem('CurrentRoute', CurrentRoute);
      !rememberMe && dispatch(setPasswordRedux(''));
      !rememberMe && dispatch(setEmailRedux(''));
      dispatch(setUserToken(''));
      dispatch(setLoginAgencyID(''));
      dispatch(setRateValues(''));
      dispatch(setQuickQuoteTLRateValues(''));
      dispatch(setQuickQuoteRateValues(''));
    }
  }, tokenExpiryTime - currentTime);

  const onIdle = () => {
    setState('Idle');
    if (UserId) {
      // alert('locked');
      history.push('/agency-locked-screen', {
        currentRoute: CurrentRoute,
        selectedModuleName: selectedModuleName
      });
      // dispatch(setUserToken(''));
      // sessionStorage.setItem('UserAuthToken', null);
    }
  };

  const onActive = () => {
    setState('Active');
  };

  const onAction = () => {
    setCount(count + 1);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    // timeout: 10000,
    timeout: 3600000,
    throttle: 500
  });

  const toggleMode = () => {
    if (layoutMode === 'dark') {
      document.body.setAttribute('data-layout-mode', 'light');
    } else {
      document.body.setAttribute('data-layout-mode', 'dark');
    }
  };
  const queryClient = new QueryClient();
  // useEffect(() => {
  //   if (!UserIsAdmin) {
  //     assignedRoutesArray.includes(CurrentRoute)
  //       ? history.push(CurrentRoute)
  //       : history.push('/dashboard');
  //   }
  // }, []);

  const handleResetLocalStorage = () => {
    !rememberMe && dispatch(setPasswordRedux(''));
    !rememberMe && dispatch(setEmailRedux(''));
    !rememberMe && dispatch(setUserDetailsObj({}));
    localStorage.clear();
    history.push('/agency-signin', 'sessionExpired');
  };

  // useEffect(() => {
  //   if (Object.keys(cookies).length === 0) {
  //     handleResetLocalStorage();
  //   }
  // }, []);

  const isMobile = useIsMobile();

  const succRes = apiRes => {
    // const oldIds = UserNotifications?.map(notif => notif.id);
    // console.log(oldIds, 'oldIdsoldIds')
    // apiRes?.data.forEach(notif => {
    //     if (!oldIds?.includes(notif.id)) {
    // enqueueSnackbar(notif.title);
    //     }
    // });

    dispatch(
      setUserAppNotifications({
        notifications: apiRes?.data,
        count: apiRes?.pagingInfo?.pageSize
      })
    );
  };

  const fetchAppNotifications = () => {
    GetAppNotifications(true, 5)
      .then(res => succRes(res?.data))
      .catch(err => {
        console.log(err, 'appNotificationError');
      });
  };

  useEffect(() => {
    if (UserId && UserId !== '') {
      fetchAppNotifications();
      const interval = setInterval(() => {
        fetchAppNotifications();
      }, 300000);

      return () => clearInterval(interval);
    }
  }, [UserId]);

  // useEffect(() => {
  //   if (
  //     routesArray &&
  //     !routesArray.includes(CurrentRoute) &&
  //     CurrentRoute !== '/' &&
  //     !UserIsAdmin
  //   ) {
  //     ErrorToast(`${CurrentRoute} is not assigned Module by Admin!`);
  //     history.replace(routesArray[0]);
  //   }
  // }, [routesArray, CurrentRoute]);

  // useEffect(() => {
  //   if (!routesArray) return;

  //   if (routesArray.includes(location.pathname) && !UserIsAdmin) {
  //     setInvalidModuleDialog(false);
  //   } else {
  //     setInvalidModuleDialog(true);
  //     // setInvalidUrl(CurrentRoute); //
  //     // history.replace('/not-assigned');
  //     setInvalidUrl(location.pathname);
  //     history.replace('/not-assigned', { invalidUrl: location.pathname });
  //   }
  // }, [location.pathname, routesArray, UserIsAdmin, history]);
  useEffect(() => {
    if (!routesArray) return;

    // Define the modulesURLs array inside useEffect to prevent unnecessary re-renders
    const modulesURLs = [
      '/quick-quote',
      '/bookshipment',
      '/dispatchshipmentLTL',
      '/bookshipmentTL',
      '/dispatchshipmentTL',
      '/bookshipmentParcel',
      '/dispatchshipmentParcel',
      '/dashboard',
      '/user-dashboard',
      '/new-dashboard',
      '/claims-dashboard',
      '/carriers',
      '/create-carrier',
      '/users',
      '/roles',
      '/manage-shipments',
      '/view-locations',
      '/add-locations',
      '/app-registration',
      '/track-shipment',
      '/Logs',
      '/dispatch',
      '/settings',
      '/user-profile',
      '/not-assigned',
      '/invoice-audit',
      '/notifications',
      '/'
    ];

    const currentPath = location.pathname;
    if (routesArray && !modulesURLs.includes(currentPath)) {
      history.push('/404');
    }
    if (routesArray && !UserIsAdmin && UserId) {
      if (currentPath === '/') {
        history.push(
          routesArray.includes('/manage-shipments')
            ? '/manage-shipments'
            : routesArray.includes('/quick-quote')
            ? '/quick-quote'
            : routesArray[0]
        );
      }
      if (routesArray.includes(currentPath)) {
        // Valid route, no action needed
      }
      if (
        modulesURLs.includes(currentPath) &&
        !routesArray.includes(currentPath)
      ) {
        localStorage.setItem('invalidUrl', currentPath);
        history.push('/not-assigned');
      }
    }
  }, [location.pathname, routesArray, UserIsAdmin, history]);

  return (
    <React.Fragment>
      {/* {location.pathname === '/not-assigned' && (
        <Dialog
          open={invalidModuleDialog}
          //  onClose={handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {'Incorrect URL or Module not Assigned!'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <Alert severity='info'>
                {invalidUrl}
                Module for the entered URL not assigned by Admin! Click on
                sidebar Modules or Contact Admin.
              </Alert>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus>
              close
            </Button>
          </DialogActions>
        </Dialog>
      )} */}

      <div
        style={
          layoutMode === 'dark'
            ? { backgroundColor: '#000' }
            : {
                backgroundColor: '#F5F5F5',
                overflowX: 'hidden',
                height: 'auto',
                minHeight: '100vh'
              }
        }
      >
        {UserId && UserId !== '' ? (
          <Grid
            container
            width={'100vw'}
            sx={{ maxHeight: '100vh', position: 'relative' }}
          >
            {/* <SnackbarProvider
              maxSnack={5}
              autoHideDuration={5000}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              className='bg-white text-black'
            /> */}

            <Grid
              item
              width={'6vw'}
              height={'100%'}
              style={{ maxHeight: '100vh' }}
            >
              <SideBar toggleMode={toggleMode} />
            </Grid>
            <Grid item width={isMobile ? '100vw' : '94vw'}>
              <NavBar toggleMode={toggleMode} />
              {props.children}
            </Grid>
          </Grid>
        ) : (
          <SignIn />
        )}
      </div>
      {/* </Suspense> */}
      {/* </QueryClientProvider> */}
    </React.Fragment>
  );
};

export default Layout;
